import React from 'react';
import { CtaBlock } from '../CtaButton';
import { AssuranceRow } from './AssuranceRow';
import { MOCKUP_URL } from '../../data/images';
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-forest px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-93" data-mp="9uwka1004tw1">
      <div className="mx-auto max-w-4xl" data-id="element-94" data-mp="53o5sqjteic0">
        <h2 id="final-heading" className="mx-auto max-w-3xl font-display text-[2.4rem] font-bold leading-[1.06] text-brand-ivory sm:text-[3.2rem]" data-id="element-95" data-mp="52leihikydvk">
          Vos prochains cours méritent{' '}
          <em className="italic text-brand-butter" data-id="element-96" data-mp="ewc2llasomaq">une préparation plus simple.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-ivory/75 sm:text-[16px]" data-id="element-97" data-mp="sro5wh30nl39">
          Accédez à un système complet de ressources pédagogiques et consacrez davantage de temps à ce qui
          compte : enseigner la coiffure.
        </p>

        <img src={MOCKUP_URL} alt="Le système complet Hair Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(0, 0, 0, 0.45))'
      }} data-id="element-98" data-mp="2pnlorqwtoqrt" />

        <p className="mt-8 font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-butter" data-id="element-99" data-mp="349ppfpujfpiv">
          Hair Instructor Ready™ – Édition Française · 6 volumes + 5 bonus
        </p>

        <CtaBlock label="Accéder à mon système maintenant" tone="dark" className="mt-6" data-id="element-100" data-mp="3e6ucrt04dr19" />
        <AssuranceRow tone="dark" className="mt-5" data-id="element-101" data-mp="3j6q4otvjls0g" />
      </div>
    </section>;
}